import { defineMessages } from '@jutro/locale';

export default defineMessages({
    groupInfoAlert: {
        id: 'ml.gateway.MLJobResultsFilterComponent.We are unable to retrieve information for this group. You may not have access or this group is invalid',
        defaultMessage: 'We are unable to retrieve information for this group. You may not have access or this group is invalid'
    },
    searchForAGroup: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Search for a Group',
        defaultMessage: 'Search for a Group'
    },
    searchBtnLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.SEARCH',
        defaultMessage: 'SEARCH'
    },
    groupName: {
        id: 'ml.gateway.MLJobResultsFilterComponent.GROUP NAME',
        defaultMessage: 'GROUP NAME'
    },
    findAGroupTitle: {
        id: 'ml.gateway.MLJobResultsFilterComponent.Find a group',
        defaultMessage: 'Find a group'
    },
    chooseGroupButtonLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.CHOOSE GROUP',
        defaultMessage: 'CHOOSE GROUP'
    },
    cancelButtonLabel: {
        id: 'ml.gateway.MLJobResultsFilterComponent.CANCEL',
        defaultMessage: 'CANCEL'
    }
});
